<template>

<app-wrapper class="list" :class="{'is-initial': is.initial, 'is-loading': is.loading}">

    <template v-if="!is.loading || !is.initial">

        <com-pagination :text="text" :total="total" :route="route" :pages="pages" :current="current" v-if="pages > 1" v-on:create="$emit('create')" />

        <app-group :nopadding="true" :bordered="true" class="list-content" v-if="total">

            <slot></slot>

        </app-group>

        <app-group :bordered="true" v-if="!total" class="list-empty">

            {{ text.empty }}

        </app-group>

        <com-pagination :text="text" :total="total" :route="route" :pages="pages" :current="current" v-on:create="$emit('create')" />

    </template>

</app-wrapper>

</template>

<script>

import comPagination from './list/Pagination'

export default {

    props: ['api', 'route', 'text'],

    components: {
        'com-pagination': comPagination
    },

    data: function() {

        return {
            is: {
                initial: true,
                loading: false
            },
            current: 1,
            pages: 1,
            total: 0,
            perpage: 10
        }

    },

    computed: {

        routePage: function() {

            return (this.$route.params.page) ? this.$route.params.page : 1

        }

    },

    watch: {

        routePage: function(n) {

            this.current = n

            this.fetch()

        }

    },

    created: function() {

        if (this.$route.params.page) this.current = parseInt(this.$route.params.page)

        this.$pubsub.$on(this.api + '/refresh', this.fetch.bind(this))

        this.fetch()

    },

    beforeDestroy: function() {

        this.$pubsub.$off(this.api + '/refresh', this.fetch.bind(this))

    },

    methods: {

        fetch: function() {

            this.is.loading = true

            this.$api.request(this.api + '/list', {
                page: this.current,
                perpage: this.perpage
            }).then(function(json) {

                this.current = json.page
                this.pages = json.pages 
                this.total = json.total

                if (this.$route.params.page && this.$route.params.page !== this.current) {

                    this.$router.replace({
                        name: this.route + '/Pagination',
                        params: {
                            page: this.current
                        }
                    })

                }

                this.$emit('update', json.items)

                this.is.loading = false
                this.is.initial = false

            }.bind(this))

        }

    }

}

</script>

<style scoped>

.list.is-loading.is-initial {
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-image: url(~@/assets/app.load.gif);
    height: 100%;
    max-height: 200px;
}

.list.is-loading:not(.is-initial) > * {
    opacity: 0.5;
}

.list-content {
    margin: 20px 0px;
}

.is-mobile .list-content {
    margin: 0px 0px 10px 0px;
    padding: 0px;
}

.is-mobile .list-content >>> .group-content {
    padding: 0px!important;
}

.list-empty {
    margin: 0px 0px 20px 0px;
    padding: 20px;
    text-align: center;
    color: var(--color-grey);
    font-size: 16px;
    font-weight: 500px;
}

</style>